import { userKey } from "../App";
import useFetchData from "./useFetchData";

export const useVipClub = () => {
    let stringValue = localStorage.getItem(userKey);
    let value = JSON.parse(stringValue);

    const requestOptions = {
        method: 'GET',  // Adjust the HTTP method as needed
    };

    if (value?.value) {
        requestOptions.headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Token ${value?.value}`
        };
    }

    const available = useFetchData(`/wallet/cashback-available/`, requestOptions);
    const levels = useFetchData(`/wallet/cashback-available/?all_level_info=yes`, requestOptions);
    const history = useFetchData(`/wallet/cashback/`, requestOptions);

    // console.log(state?.data?.data);

    return {
        availableCasback: available?.data?.data,
        allClubLevels: levels?.data?.data,
        cashbackHistory: history?.data?.data,
    }
};

